import React, { useState, useRef, useEffect } from "react";
import "../ChatPopup.css";
import ChatAI from "./ai";


 function ChatbotDropdown() {
  const [dropdown, setDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [dropdownRef]);

  const handleDropdownClick = () => {
    setDropdown(!dropdown);
  };

  return (
    <>
  
    <div className="App">
    <div className="dropdown" ref={dropdownRef}>
      <button onClick={handleDropdownClick} className="dropbtn">
        <img  alt="Slack Flow AI"src="https://drive.google.com/uc?export=view&id=1SjPmGLScgpO6L6Roz-MSKUd9DavJCj3K"/>
      </button>
      <div
        id="myDropdown"
        className={`dropdown-content ${dropdown ? "show" : ""}`}
      > 
          {/* <textarea rows="4" cols="50" name="comment" form="usrform">
      Enter text here...</textarea>
    <p>The text area above is outside the form element, but should still be a part of the form.</p>  */}
      <ChatAI/>
      </div>
    </div>
   
  </div></>
    
    
  );
}


export default ChatbotDropdown;

